<template>
    <div
        v-if="!!$slots['default']"
        class="form-hint"
    >
        <slot />
    </div>
</template>
